import React from 'react'
import Modal from 'react-bootstrap/Modal'
import PropTypes from "prop-types";
import './SetPopup.scss';

export function SetPopup(props) {
    return (
        <Modal dialogClassName="modal__dialog" show={props.isOpen} className={`set-popup ${props.className}`} centered>
            <Modal.Header className="modal__header p-0 d-block w-100">
                {props.headerTitle ? <div className="d-block w-100">
                    <h2 className="set-popup-title">{props.headerTitle}</h2>
                </div> : ""}
                <button className="closeicon" onClick={ props.closePopup }>
                    <img src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body className="modal__body">
                {props.dialogMsg ? <h3 className="modal__body__title">{props.dialogMsg}</h3> : ""}
                {(props.subInfo) ? <div className="modal__body__content">{props.subInfo}</div> : ""}
            </Modal.Body>
            <Modal.Footer className="modal__footer">
                {(props.footerInfo) ? <div className="modal__footer__content w-100">{props.footerInfo}</div> : ""}
            </Modal.Footer>
        </Modal>
    )
}

SetPopup.propTypes = {
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  headerTitle: PropTypes.string,
  dialogMsg: PropTypes.node,
  subInfo: PropTypes.string,
  footerInfo: PropTypes.string,
  closedisplay: PropTypes.bool,
  closePopup: PropTypes.func,
};

SetPopup.defaultProps = {
    isOpen: PropTypes.bool,
    className: PropTypes.string,
    headerTitle: "",
    dialogMsg: "",
    subInfo: PropTypes.string,
    footerInfo: PropTypes.string,
    closedisplay: PropTypes.bool,
    closePopup: PropTypes.func,
};